var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-module"),
      _c("section", { staticClass: "pa pa--t_md pa--b_md" }, [
        _c("div", { staticClass: "ug-container ug-container--variant_large" }, [
          _c(
            "div",
            { staticClass: "ug-row ug-row--apearance_spaced ug-row--space_md" },
            [
              _c(
                "div",
                { staticClass: "ug-cell ug-cols ug-cols--12 ug-cols--9-mac" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--justify_center"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg"
                        },
                        [
                          _c("day-stats-panel", {
                            attrs: { "object-item": _vm.weekInfo }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg"
                        },
                        [_c("send-message-cabinet")],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg"
                        },
                        [
                          _c("numbers-panel", {
                            attrs: { "object-item": _vm.weekInfo }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ug-cell ug-cols ug-cols--12" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pa pa--t_1sm pa--t_md-md pa--r_1sm pa--r_md-md pa--l_1sm pa--l_md-md pa--b_1sm bg bg--white"
                            },
                            [
                              _c(
                                "text-bemto",
                                {
                                  staticClass: "ma ma--b_xs ma--b_md-md",
                                  attrs: {
                                    fw: "bold",
                                    lh: "small",
                                    fs: "xl",
                                    color: "black",
                                    tag: "p"
                                  }
                                },
                                [_vm._v("Orders (Monday to Sunday)")]
                              ),
                              Object.keys(_vm.statisticsItems).length
                                ? _c("statistics-table", {
                                    attrs: {
                                      "object-list": _vm.statisticsItems
                                    },
                                    on: { ordering: _vm.setOrderingHandler }
                                  })
                                : _vm._e(),
                              !Object.keys(_vm.statisticsItems).length
                                ? _c(
                                    "div",
                                    { staticClass: "text pa pa--b_xs-md" },
                                    [_vm._v("No results")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c("pagination-module", {
                    staticClass: "ma ma--t_md",
                    attrs: {
                      pagination: _vm.pagination,
                      extra: 1,
                      "need-add-btns": true
                    },
                    on: {
                      "update-limit": _vm.setPaginationLimitHandler,
                      input: function($event) {
                        _vm.pageСhangedHandler($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "ug-cell ug-cols ug-cols--12 ug-cols--3-mac" },
                [
                  _c("quick-qoute-state-form", {
                    attrs: {
                      "services-items": _vm.servicesItems,
                      "object-item": _vm.weekInfo
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11827952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11827952","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Pages/Cabinet/StatisticsCabinet.vue
// module id = 833
// module chunks = 0